import {stringValue} from 'vega-util';

export default function(obj, key, value) {
  return obj + '[' + stringValue(key) + ']=' + value + ';';
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/encode/set.js
// module id = null
// module chunks = 